<template lang='pug'>
  b-modal(
    :visible="show",
    no-close-on-backdrop)
    template(#modal-header)
      span.title {{$t('edit_application')}}
    b-container(fluid)
      b-card.w-100.mb-3(no-body)
        b-list-group(flush)
          b-list-group-item
            b-row
              b-col.d-flex.align-items-center(cols="12" sm="3") {{$t('package_id')}}
              b-col(cols="12" sm="9")
                b-form-input(v-model="appInfo.package_id")
      b-card.w-100.mb-3(no-body)
        b-list-group(flush)
          b-list-group-item
            b-row
              b-col.d-flex.align-items-center(cols="12" sm="3") {{$t('application')}} {{$t('name')}}
              b-col(cols="12" sm="9")
                b-form-input(v-model="appInfo.app_name")
      b-card.w-100.mb-3(no-body)
        b-list-group(flush)
          b-list-group-item
            b-row
              b-col.d-flex.align-items-center(cols="12" sm="3") {{$t('version')}}
              b-col(cols="12" sm="9")
                b-form-input(v-model="appInfo.app_version")
                b-row.pl-3.mt-2
                  label.d-flex
                    b-form-checkbox(v-model="appInfo.run_after_installation")
                    span {{$t('run_after_installation')}}
    
    template(#modal-footer)
      b-btn(:disabled="appInfo.package_id === ''" size="sm", variant="primary",  @click="handleEdit") {{$t('confirm')}}
      b-btn(size="sm", @click="close") {{$t('cancel')}}
</template>

<script>
import { ApplicationsAPI } from '@/api'

export default {
  name: 'DialogApplicationEdit',
  props: {
    show: Boolean,
    pk: Number,
  },
  data() {
    return {
      appInfo: {
        package_id: '',
        file_name: '',
        app_name: '',
        app_version: '',
        run_after_installation: 'false',
      },
    }
  },
  mounted() {
    this.fetchApplicationInfo(this.pk)
  },
  methods: {
    close() {
      this.appInfo = {
        package_id: '',
        file_name: '',
        app_name: '',
        app_version: '',
        run_after_installation: false,
      }
      this.$emit('close')
    },
    handleEdit() {
      let params = {
        package_id: this.appInfo.package_id,
        file_name: this.appInfo.file_name,
        app_name: this.appInfo.app_name,
        app_version: this.appInfo.app_version,
        run_after_installation: this.appInfo.run_after_installation,
      }
      ApplicationsAPI.put(`${this.pk}`, params)
          .then(res => {
            if (res.data.objects && res.data.objects.hasOwnProperty('error')) {
              throw new Error(res.data.objects.error)
            }
            this.$awn.success(this.$t('app_info_updated'))
            this.close()
          })
          .catch(error => {
            this.$log.error(this.$t('invalid_value'))
            this.$awn.alert(this.$t('invalid_value'))
          })
    },
    async fetchApplicationInfo(pk) {
      if (pk !== null) {
        let res = await ApplicationsAPI.get(`${pk}`)
        let resData = res.data.objects.find(item => item.pk === pk)
        this.appInfo.package_id = resData.package_id
        this.appInfo.file_name = resData.file_name
        this.appInfo.app_name = resData.app_name
        this.appInfo.app_version = resData.app_version
        this.appInfo.run_after_installation = Boolean(resData.run_after_installation)
      }
    },
  },
  watch: {
    pk(newVal) {
      this.fetchApplicationInfo(newVal)
    },
  },
}
</script>

<style scoped lang="scss">
.title {
  font-size: 20px;
  font-weight: 500;
  color: #f0f0f0;
  line-height: 100%;
  letter-spacing: -.5px;
}

::v-deep .modal-dialog {
  max-width: 800px;
}

.col-3 {
  display: flex;
  align-items: center;
}
</style>